import React from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import "./BookingItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Flex, Tooltip } from "antd";
import { Facility } from "../../types/Structure";
import { getSportName } from "../../utils/stringUtil";

type Props = {
  facility: Facility;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onView?: React.MouseEventHandler<HTMLButtonElement>;
  onEdit?: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
};

function FacilityItem({ facility, onClick, onEdit, onDelete, onView }: Props) {
  return (
    <Card className="app-list-item" onClick={onClick}>
      <Card.Body className="d-flex flex-column gap-4 justify-content-around">
        <Flex align="center" justify="space-between">
          <Badge bg="warning">
            <small className="text-start">{facility.type}</small>
          </Badge>
          <Badge bg="success">
            <small className="text-end">
              {getSportName(facility.sport?.name || "")}
            </small>
          </Badge>
        </Flex>
        <div
          className="mx-auto"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h5 className="mb-5">{facility.name}</h5>
          <Flex gap={8}>
            <Badge bg="primary">
              <small>{facility.timeSlots.filter((timeSlot) => timeSlot.enabled).length || 0} Giorni attivi</small>
            </Badge>
          </Flex>
        </div>
        <Row className="gx-0 mt-3 justify-content-center">
          <Col className="text-center" xs={8}>
            <Tooltip title="Vedi Dettagli Campo" mouseEnterDelay={0.3}>
              <button className="circle-button ms-2" onClick={onView}>
                <FontAwesomeIcon size="sm" icon={faEye} />
              </button>
            </Tooltip>
            <Tooltip title="Modifica Dettagli Campo" mouseEnterDelay={0.3}>
              <button className="circle-button ms-2" onClick={onEdit}>
                <FontAwesomeIcon size="sm" icon={faPencil} />
              </button>
            </Tooltip>
            <Tooltip title="Cancella Campo" mouseEnterDelay={0.3}>
              <button className="circle-button ms-2" onClick={onDelete}>
                <FontAwesomeIcon size="sm" icon={faTrash} />
              </button>
            </Tooltip>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default FacilityItem;
